import * as i0 from '@angular/core';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';

/**
 * Configures the MatIconRegistry to use the
 * one-icons font per default.
 */
function configureMatIconRegistry(matIconRegistry) {
    let compile;
    compile = () => {
        matIconRegistry.setDefaultFontSetClass('one-icons-legacy');
        return Promise.resolve();
    };
    return compile;
}
class OneIconModule {
}
OneIconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneIconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneIconModule, imports: [MatIconModule], exports: [MatIconModule] });
OneIconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneIconModule, providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: configureMatIconRegistry,
            multi: true,
            deps: [MatIconRegistry]
        }
    ], imports: [[MatIconModule], MatIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneIconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [MatIconModule],
                    providers: [
                        {
                            provide: APP_INITIALIZER,
                            useFactory: configureMatIconRegistry,
                            multi: true,
                            deps: [MatIconRegistry]
                        }
                    ],
                    exports: [MatIconModule]
                }]
        }] });

/*
 * Public API Surface of layout
 */

/**
 * Generated bundle index. Do not edit.
 */

export { OneIconModule };
